import * as SlotFamilyType from '../constants/SlotFamilyType';

export default function customSlotIdProvider(slotType, slotFamily, rate) {
    const outcomeId = rate.get('outcomeId');
    const rateValue = rate.get('value');

    switch (slotFamily) {
        case SlotFamilyType.SINGLE_OUTCOME:
        case SlotFamilyType.WIDE_SINGLE_OUTCOME:
            return `${slotType}_${rateValue}_${outcomeId}`;
    }

    return slotType;
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/providers/CustomSlotIdProvider.js